/* tslint:disable */
/* eslint-disable */
/**
 * Animare Management API
 * This API provides methods for viewing and modifying animare database data for authorities. 
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteMicrochipRequestDto
 */
export interface DeleteMicrochipRequestDto {
    /**
     * When the microchip deletion form has arrived (only for paper registration).
     * @type {Date}
     * @memberof DeleteMicrochipRequestDto
     */
    arrivalDate: Date;
}

/**
 * Check if a given object implements the DeleteMicrochipRequestDto interface.
 */
export function instanceOfDeleteMicrochipRequestDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "arrivalDate" in value;

    return isInstance;
}

export function DeleteMicrochipRequestDtoFromJSON(json: any): DeleteMicrochipRequestDto {
    return DeleteMicrochipRequestDtoFromJSONTyped(json, false);
}

export function DeleteMicrochipRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteMicrochipRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'arrivalDate': (new Date(json['arrivalDate'])),
    };
}

export function DeleteMicrochipRequestDtoToJSON(value?: DeleteMicrochipRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'arrivalDate': (value.arrivalDate.toISOString().substr(0,10)),
    };
}

